import {
  ButtonStyle,
  type ButtonStyleClasses,
  getButtonStyleClasses,
} from '@davidlloydleisure/common-js-frontend';

import * as redesignButtonStyles from 'src/styling/redesign-button-variants.module.scss';

import { BuildType } from 'src/enums/build/build-type';
import {
  RedesignButtonStyle,
  RedesignHarbourButtonStyle,
  RedesignMeridianButtonStyle,
} from 'src/enums/button-style';
import { getBrandForBuildType } from 'src/helpers/brand-for-build-type';
import { tryGetButtonStyle } from 'src/helpers/button-styles';

import type { GeneralRedesignButtonStyle } from '../../../cms/common-widgets/button-widget';

export const getButtonClassName = (
  buttonStyle: GeneralRedesignButtonStyle | string | null | undefined
): string | undefined => {
  switch (buttonStyle) {
    case RedesignButtonStyle.PLUM:
      return redesignButtonStyles.plum;
    case RedesignButtonStyle.TRANSPARENT_WITH_PLUM_FONT:
      return redesignButtonStyles.transparent;
    case RedesignButtonStyle.TRANSPARENT_WITH_WHITE_FONT:
      return redesignButtonStyles.transparentWithWhiteFont;
    case RedesignButtonStyle.DARK_GREEN:
      return redesignButtonStyles.darkGreen;
    case RedesignButtonStyle.WHITE_WITH_GREEN_FONT:
      return redesignButtonStyles.whiteWithGreenFont;
    case RedesignButtonStyle.WHITE_WITH_PLUM_FONT:
      return redesignButtonStyles.whiteWithPlumFont;
    case RedesignMeridianButtonStyle.ORANGE:
      return redesignButtonStyles.orange;
    case RedesignMeridianButtonStyle.BLUE:
      return redesignButtonStyles.blue;
    case RedesignMeridianButtonStyle.TRANSPARENT_WITH_WHITE_FONT_AND_BORDER:
      return redesignButtonStyles.transparentWithWhiteFontAndBorder;
    case RedesignMeridianButtonStyle.TRANSPARENT_WITH_BLUE_FONT_AND_BORDER:
      return redesignButtonStyles.transparentWithBlueFontAndBorder;
    case RedesignMeridianButtonStyle.WITHOUT_BORDERS_WITH_WHITE_FONT:
      return redesignButtonStyles.withoutBordersWithWhiteFont;
    case RedesignMeridianButtonStyle.WITHOUT_BORDERS_WITH_BLUE_FONT:
      return redesignButtonStyles.withoutBordersWithBlueFont;
    case RedesignHarbourButtonStyle.HARBOUR_GREY_WITH_WHITE_FONT:
      return redesignButtonStyles.harbourGreyWithWhiteFont;
    case RedesignHarbourButtonStyle.TRANSPARENT_WITH_GREY_FONT_AND_BORDER:
      return redesignButtonStyles.transparentWithGreyFontAndBorder;
    case RedesignHarbourButtonStyle.TRANSPARENT_WITH_GOLD_FONT_AND_BORDER:
      return redesignButtonStyles.transparentWithGoldFontAndBorder;
    case RedesignHarbourButtonStyle.WHITE_WITH_HARBOUR_GREY_FONT:
      return redesignButtonStyles.whiteWithHarbourGreyFont;
    default:
      return undefined;
  }
};

export const getDefaultButtonClassName = (buildType: BuildType): string | undefined => {
  if (buildType === BuildType.MERIDIAN)
    return getButtonClassName(RedesignMeridianButtonStyle.ORANGE);
  if (buildType === BuildType.HARBOUR)
    return getButtonClassName(RedesignHarbourButtonStyle.HARBOUR_GREY_WITH_WHITE_FONT);
  return getButtonClassName(RedesignButtonStyle.PLUM);
};

export const getDefaultSecondaryButtonClassName = (buildType: BuildType): string | undefined => {
  if (buildType === BuildType.MERIDIAN)
    return getButtonClassName(RedesignMeridianButtonStyle.TRANSPARENT_WITH_BLUE_FONT_AND_BORDER);
  if (buildType === BuildType.HARBOUR)
    return getButtonClassName(RedesignHarbourButtonStyle.TRANSPARENT_WITH_GREY_FONT_AND_BORDER);
  return getButtonClassName(RedesignButtonStyle.TRANSPARENT_WITH_PLUM_FONT);
};

export const getRedesignButtonStyleClasses = (
  buttonStyle: GeneralRedesignButtonStyle | string | null | undefined,
  buildType: BuildType
): ButtonStyleClasses =>
  getButtonStyleClasses({
    style: tryGetButtonStyle(buttonStyle) ?? ButtonStyle.PRIMARY,
    brand: getBrandForBuildType(buildType),
  });
